var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "advantage-card"
  }, [_c("section", {
    staticClass: "advantage-card__top"
  }, [_c("img", {
    staticClass: "img-bg",
    attrs: {
      src: require(`@/assets/images/service/self-select-stock/${_vm.img}`),
      alt: ""
    }
  }), _c("img", {
    staticClass: "img-icon",
    attrs: {
      src: require(`@/assets/images/service/self-select-stock/${_vm.icon}`),
      alt: ""
    }
  })]), _c("section", {
    staticClass: "advantage-card__bottom"
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))]), _c("section", {
    staticClass: "desc"
  }, _vm._l(_vm.paragraph, function (item, index) {
    return _c("p", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };